import { useTranslation } from 'react-i18next';

import { ErrorBanner } from '@saas-kit/ui';

import type { AdminSubscription } from './api';

interface Props {
  subscription: AdminSubscription | null;
  isLoading: boolean;
  isError: boolean;
}

export function SubscriptionSummary({
  subscription,
  isLoading,
  isError,
}: Props): JSX.Element {
  const { t } = useTranslation('adminBilling');
  if (isLoading) {
    return (
      <p className="text-sm text-muted-foreground">{t('subscription.loading')}</p>
    );
  }
  if (isError) {
    return <ErrorBanner>{t('subscription.error')}</ErrorBanner>;
  }
  if (!subscription) {
    return (
      <p className="text-sm text-muted-foreground">{t('subscription.missing')}</p>
    );
  }
  return (
    <dl className="grid grid-cols-2 gap-x-4 gap-y-2 text-sm sm:grid-cols-4">
      <div>
        <dt className="text-xs text-muted-foreground">{t('subscription.status')}</dt>
        <dd className="font-medium">{subscription.status}</dd>
      </div>
      <div>
        <dt className="text-xs text-muted-foreground">
          {t('subscription.billing_mode')}
        </dt>
        <dd className="font-medium">{subscription.billing_mode}</dd>
      </div>
      <div>
        <dt className="text-xs text-muted-foreground">
          {t('subscription.period_start')}
        </dt>
        <dd>
          {new Date(subscription.current_period_starts_at).toLocaleDateString()}
        </dd>
      </div>
      <div>
        <dt className="text-xs text-muted-foreground">
          {t('subscription.period_end')}
        </dt>
        <dd>
          {new Date(subscription.current_period_ends_at).toLocaleDateString()}
        </dd>
      </div>
    </dl>
  );
}
